// extracted by mini-css-extract-plugin
module.exports = {"checkboxReplacement":"OrderControl_checkboxReplacement__hv3_r"};